import { atom } from 'jotai';

/**
 * `true` while the status read is `unverified` or `rejected`. Written by
 * `HcpVerificationBadgeProbe`, read by `launchModalsAtom` for the weekly
 * reminder row; `false` (verified, in review, flag OFF, probe unmounted) drops
 * the row on the next recompute.
 *
 * Not importing `modalQueueAtoms` here: it imports `launchModalsConfigAtom`,
 * which imports this file. The queue items it pairs with live in
 * `ui/hcp-verification/hcp-verification-queue-items.ts`.
 */
export const hcpVerificationReminderEligibleAtom = atom<boolean>(false);
